import { render, staticRenderFns } from "./TestApi.vue?vue&type=template&id=5c6de713&scoped=true&"
import script from "./TestApi.vue?vue&type=script&lang=js&"
export * from "./TestApi.vue?vue&type=script&lang=js&"
import style0 from "./TestApi.vue?vue&type=style&index=0&id=5c6de713&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6de713",
  null
  
)

export default component.exports